import React from 'react';
import styles from '../Operations.module.css';

interface SO01Component extends React.FC {
  title?: string;
  kpiHyperlink?: string;
}

/**
 * SOCIACTIVE - SOCI - Active On Program
 * KPI information component
 */
const SO01: SO01Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Shows if your store&apos;s social site is connected to the SOCi platform for the month.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        The information is a monthly, direct feed from the SOCi platform.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Connect your social sites to the SOCi platform.<br/>
        Questions: email <strong>onboarding@meetsoci.com</strong>
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Manage all social engagements and reviews via SOCi &lt; 24 hours.<br/>
        Sign-up and Questions:
        <ol>
          <li>
            Sign-ups at no charge for the platform, visit{' '}
            <a
              href="https://www.soci.ai/acehardware/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}>
              www.soci.ai/acehardware/
            </a>
          </li>
          <li>Questions? Email: support@meetsoci.com</li>
        </ol>
      </div>
    </div>
  );
};

SO01.title = 'SOCi - Active On Program';
SO01.kpiHyperlink = 'https://www.meetsoci.com/acehardware/';
export default SO01;

